// Only two things are persisted locally: chosen zone and the dismissed geolocation prompt.
const KEY_ZONE = 'dinkr.zone';
const KEY_GEO_DISMISSED = 'dinkr.geo_dismissed';

function read(key: string): string | null {
  try {
    return localStorage.getItem(key);
  } catch {
    return null;
  }
}
function write(key: string, value: string | null): void {
  try {
    if (value == null) localStorage.removeItem(key);
    else localStorage.setItem(key, value);
  } catch {
    /* private mode / blocked storage — ignore */
  }
}

export const prefs = {
  getZone: (): string | null => read(KEY_ZONE),
  setZone: (z: string | null) => write(KEY_ZONE, z),
  geoDismissed: (): boolean => read(KEY_GEO_DISMISSED) === '1',
  setGeoDismissed: (v: boolean) => write(KEY_GEO_DISMISSED, v ? '1' : null),
};
